<template>
    <div class="legend-item-loe" v-if="loe_dates">
        <div
            v-for="date in loe_dates"
            :key="date.id"
            class="loe-date-item-container"
            :id="'loe-date-item-' + date.id"
            @click="handleOnClick(date)"
            @mouseover="showLoeTooltip(date)"
            @mouseleave="hideLoeTooltip()"
        >
            <div v-if="date.loe_date != null" class="loe-date-item">
                <div class="content">
                    <span class="label">LOE:</span>
                    <span class="value">{{ date.loe_date }}</span>
                </div>
                <svg class="ico" width="12" height="12">
                    <use xlink:href="#ico-edit"></use>
                </svg>
            </div>
            <div v-else class="loe-date-item-container loe-date-item add-loe-date">
                <div class="content">
                    + ADD LOE
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as d3 from "d3";

export default {
    props: {
        chart: {
            type: Object
        },
        loe_dates: {
            type: Array
        }
    },
    methods: {
        showLoeTooltip(date) {
            if (this.loe_dates === null || this.loe_dates.length < 2) return;
            const elementRef = "loe-date-item-" + date.id;
            const refElement = this.$el
                .querySelector(`#view-chart-${this.chart.chartId} #${elementRef} .content`)
                .getBoundingClientRect();
            const tooltip = d3.select(`#view-chart-${this.chart.chartId}`).select(".loe-tooltip");
            const textToDisplay = `${date.loe_date == null ? "Add" : "Edit"} LoE for ${
                date.brand_name
            }`;

            tooltip.select("span").html(textToDisplay);
            if (refElement && refElement.x && refElement.y) {
                let left = refElement.width + 14;
                // add edit icon width plus its margin
                if (date.loe_date != null) left += 24;
                tooltip.attr("style", `top: ${refElement.y - 57}px; left: ${left}px;`);
            }
            tooltip.classed("open", true);
        },
        hideLoeTooltip() {
            const tooltip = d3.select(`#view-chart-${this.chart.chartId}`).select(".loe-tooltip");
            tooltip.classed("open", false);
        },
        handleOnClick(date) {
            this.$emit("modifyLoe", date);
        }
    }
};
</script>

<style lang="scss">
@import "../../../style/Charts/ViewChart/LegendItemLoe.scss";
</style>
